import React, { useEffect, useState, useCallback, memo, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import Customer from './Customer';
import Recipient from './Recipient';
import Cakes from './Cakes.js';
import Cupcakes from './Cupcakes';
import CakePops from './CakePops';
import Cookies from './Cookies';
import GeneralItems from './GeneralItems';
import FeeItems from './FeeItems';
import DiscountItems from './DiscountItems';
import { Menubar } from 'primereact/menubar';
import { TabView, TabPanel } from 'primereact/tabview';
import Attachments from './Attachments';
import { OrderService } from './../service/OrderService';
import { Steps } from 'primereact/steps';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { Input, Container, useInput, Card as NextCard, Spacer, Text, Grid, Collapse } from "@nextui-org/react";
import { Avatar } from 'primereact/avatar';
import { FaRegCalendarAlt, FaRegClock, FaTruck, FaWalking } from 'react-icons/fa'; // Ensure to import these icons
import { Toast } from 'primereact/toast';
import { InputNumber } from 'primereact/inputnumber';
import { EditableField, NonEditableField } from './Fields';
import './OrderViewEdit.css'; // Import the CSS file

import PhotoManager from './PhotoManager.js';

import { formatDateLong, formatDateWeekday, formatToUSD, generateOrderDescription } from '../../utils.js';

import { FaBirthdayCake, FaCookieBite, FaIceCream, FaGift, FaCandyCane, FaPercentage } from 'react-icons/fa';

import { CiLollipop } from "react-icons/ci";
import { GiCupcake } from "react-icons/gi";


const generateAdditionalFee = () => ({
  description: '',
  price: 0,
});

const generateDiscount = () => ({
  description: '',
  price: 0,
});

const generateCake = () => ({
  tiers: [
    {
      size: 6,
      shape: 'Round',
      layers: 3,
      flavor: '',
      filling: '',
      premiumFilling: '',
      premiumFillingPrice: '',
      soak: '',
      finalIcing: '',
      exteriorIcing: '',
      inscription: '',
      price: '',
      dateBaked: '',
      bakingNotes: '',
      decoratingNotes: '',
      extras: '',
      extrasPrice: '',
    },
  ],
  toppers: [],
  decoratingItems: [],
  cakeBoardShape: 'Round',
  cakeBoardSize: 8,
  cakeBoardType: '',
  cakeBoardColor: '',
  cakeBoardNote: '',
  cakeBoardInscription: '',
  specialInstructions: '',
  bakingDate: '',
  assignedBaker: '',
  bakingNotes: '',
  crumbCoatDate: '',
  assignedCrumbCoater: '',
  crumbCoatingNotes: '',
  decoratingDate: '',
  assignedDecorator: '',
  decoratingNotes: '',
  price: '',//not used
  description: '',
});

const generateCookies = () => ({
  description: '',
  quantity: 0,
  shape: 'Round',
  flavor: 'Sugar',
  icing: '',
  icingColor: '',
  bakingDate: '',
  assignedBaker: '',
  decoratingDate: '',
  assignedDecorator: '',
  decoratingNotes: '',
  bakingNotes: '',
  price: 0,
  toppers: [],
  decoratingItems: [],
});

const generateCakePops = () => ({
  description: '',
  quantity: 0,
  shape: '',
  flavor: '',
  type: '',
  chocolateCoating: '',
  coatingColor: '',
  decoratingNotes: '',
  bakingDate: '',
  assignedBaker: '',
  decoratingDate: '',
  assignedDecorator: '',
  stickOrientation: '',
  bakingNotes: '',
  price: 0,
  toppers: [],
  decoratingItems: [],
});

const generateCupcakes = () => ({
  description: '',
  quantity: 0,
  flavor: '',
  filling: '',
  finalIcing: '',
  finalIcingColor: '',
  decoratingNotes: '',
  bakingDate: '',
  assignedBaker: '',
  decoratingDate: '',
  assignedDecorator: '',
  bakingNotes: '',
  price: 0,
  toppers: [],
  decoratingItems: [],
});

const generateGeneralItems = () => ({
  description: '',
  item: '',
  quantity: 0,
  flavor: '',
  flavorNotes: '',
  bakingDate: '',
  assignedBaker: '',
  decoratingDate: '',
  assignedDecorator: '',
  decoratingNotes: '',
  bakingNotes: '',
  price: 0,
  toppers: [],
  decoratingItems: [],
});

const mergeUniquePhotos = (existing = [], toAdd = []) => {
  const out = [...existing];
  const seen = new Set(existing.map(p => p.url));
  for (const p of toAdd) {
    if (!seen.has(p.url)) {
      out.push(p);
      seen.add(p.url);
    }
  }
  return out;
};



const OrderViewEdit = ({ order, selectedOrderInvoice, productProperties, orderProperties, editable, employees, setEditable, refreshOrders, setSelectedOrder, PotentialInvoices, linkInvoiceToOrder, isSaving, setIsSaving, customers, filteredPhoneNumbers, filteredEmails }) => {

  const { value, reset, bindings } = useInput("");

  const toast = React.useRef(null);

  const helper = React.useMemo(() => {
    if (!value)
      return {
        text: "",
        color: "",
      };
  }, [value]);

  const [activeIndex, setActiveIndex] = useState(0);
  const orderStepItems = [
    {
      label: 'Details',
    },
    {
      label: 'Payments',
    },
    {
      label: 'Completion',
    }
  ];
  const [tempOrder, setTempOrder] = useState(order || {
    name: '',
    description: '',
    orderNote: '',
    price: '',
    type: '',
    quantity: '1',
    orderStatus: 'New Order',
    invoiceStatus: 'Not Sent',
    priority: '',
    customer: {
      name: '',
      lastName: '',
      phone: '',
      email: '',
      contactDate: new Date(),
      squareID: '',
      internal_notes: '',
    },
    dueDate: new Date(),
    scheduledTime: '11:00',
    // scheduledTimeEnd: '11:00',
    deliveryAddress: '',
    deliveryFee: 0,
    budget: '',
    ocassion: '',
    theme: '',
    servings: '',
    photoAttached: false,
    photos: [],
    recipient: {
      name: '',
      age: 0,
    },
    orderItems: [{
      cakes: [],
      cookies: [],
      cakePops: [],
      cupcakes: [],
      generalItems: [],
    }],
    attachments: [],
    squareCustomerID: '',
    squareInvoiceID: '',
    orderID: '',
    additionalFees: [],
    discounts: [],
  });

  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);


  useEffect(() => {
    setTempOrder(JSON.parse(JSON.stringify(order)));
  }, [order]);
 

  const orderRef = useRef(tempOrder);
  useEffect(() => { orderRef.current = tempOrder; }, [tempOrder]);


  const openDialog = (index) => {
    setCurrentPhotoIndex(index);
    setIsDialogVisible(true);
  };

  const closeDialog = () => {
    setIsDialogVisible(false);
  };

  const handleNavigation = (direction) => {
    if (!tempOrder.photos) return;
    let newIndex = currentPhotoIndex + direction;
    if (newIndex < 0) newIndex = tempOrder.photos.length - 1;
    if (newIndex >= tempOrder.photos.length) newIndex = 0;
    setCurrentPhotoIndex(newIndex);
  };

  const downloadPhoto = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = url.split('/').pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  if (!tempOrder) {
    return null;
  }



  // Function to handle adding a new photo (batch-friendly; no server patch here)
const handleAddPhoto = async (file, tag, type, onProgress) => {
  if (!file) return;

  const { dueDate, customer } = tempOrder;
  if (!dueDate || !customer?.name) {
    toast.current?.show({
      severity: 'warn',
      summary: 'Incomplete Order',
      detail: 'Order Due Date and Customer Name are required to upload a photo.'
    });
    // important: stop this upload so PhotoManager can leave it as "not started"
    throw new Error('Missing required order fields');
  }

  try {
    // 1) Upload to Cloudinary
    const { url } = await OrderService.uploadImage(file, dueDate, customer.name, onProgress);
    const newPhoto = { url, tag, type };

    // 2) Update ONLY local state; server commit happens once via handleSave
     setTempOrder(prev => ({
        ...prev,
        photos: mergeUniquePhotos(prev.photos, [newPhoto]),
        photoAttached: true
      }));

    return newPhoto; // optional, lets caller know success
  } catch (err) {
    // surface error + rethrow so the row shows failure
    console.error('Error adding photo:', err);
    toast.current?.show({
      severity: 'error',
      summary: 'Upload failed',
      detail: err?.message || 'Failed to upload photo.'
    });
    throw err;
  }
};




  // Function to handle removing a photo
  const handleRemovePhoto = (index) => {
    setTempOrder(prevOrder => {
      const updatedPhotos = [...prevOrder.photos];
      updatedPhotos.splice(index, 1);
      return {
        ...prevOrder,
        photos: updatedPhotos,
        photoAttached: updatedPhotos.length > 0,
      };
    });
  };

  const addAttachment = (file) => {
    setTempOrder(prevOrder => {
      const updatedAttachments = JSON.parse(JSON.stringify(prevOrder.attachments));
      updatedAttachments.push(file);
      return {
        ...prevOrder,
        attachments: updatedAttachments,
      };
    });
  };

  const removeAttachment = (index) => {
    setTempOrder(prevOrder => {
      const updatedAttachments = JSON.parse(JSON.stringify(prevOrder.attachments));
      updatedAttachments.splice(index, 1);
      return {
        ...prevOrder,
        attachments: updatedAttachments,
      };
    });
  };

  const addAdditionalFee = () => {
    setTempOrder(prevOrder => {
      const updatedAdditionalFees = JSON.parse(JSON.stringify(prevOrder.additionalFees));
      updatedAdditionalFees.push(generateAdditionalFee());
      return {
        ...prevOrder,
        additionalFees: updatedAdditionalFees,
      };
    });
  };

  const addDiscount = () => {
    setTempOrder(prevOrder => {
      const updatedDiscounts = JSON.parse(JSON.stringify(prevOrder.discounts));
      updatedDiscounts.push(generateDiscount());
      return {
        ...prevOrder,
        discounts: updatedDiscounts,
      };
    });
  };

  const addCake = () => {
    setTempOrder(prevOrder => {
      const updatedOrderItems = { ...JSON.parse(JSON.stringify(prevOrder.orderItems[0])) }; // Get the first object directly
      if (!updatedOrderItems.cakes) {
        updatedOrderItems.cakes = [generateCake()];
      } else {
        updatedOrderItems.cakes.push(generateCake());
      }
      return {
        ...prevOrder,
        orderItems: [updatedOrderItems], // Wrap the object back into an array
      };
    });
  };


  const addCookies = () => {
    setTempOrder(prevOrder => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      if (!updatedOrderItems[0].cookies) {
        updatedOrderItems[0].cookies = [generateCookies()];
      } else {
        updatedOrderItems[0].cookies.push(generateCookies());
      }
      return {
        ...prevOrder,
        orderItems: updatedOrderItems,
      };
    });
  };

  const addCakePops = () => {
    setTempOrder(prevOrder => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      if (!updatedOrderItems[0].cakePops) {
        updatedOrderItems[0].cakePops = [generateCakePops()];
      } else {
        updatedOrderItems[0].cakePops.push(generateCakePops());
      }
      return {
        ...prevOrder,
        orderItems: updatedOrderItems,
      };
    });
  };

  const addCupcakes = () => {
    setTempOrder(prevOrder => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      if (!updatedOrderItems[0].cupcakes) {
        updatedOrderItems[0].cupcakes = [generateCupcakes()];
      } else {
        updatedOrderItems[0].cupcakes.push(generateCupcakes());
      }
      return {
        ...prevOrder,
        orderItems: updatedOrderItems,
      };
    });
  };

  const addGeneralItems = () => {
    setTempOrder(prevOrder => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      if (!updatedOrderItems[0].generalItems) {
        updatedOrderItems[0].generalItems = [generateGeneralItems()];
      } else {
        updatedOrderItems[0].generalItems.push(generateGeneralItems());
      }
      return {
        ...prevOrder,
        orderItems: updatedOrderItems,
      };
    });
  };

  const handleCustomerChange = (customer) => {
    setTempOrder((prevOrder) => ({ ...prevOrder, customer }));
  };

  const handleRecipientChange = (recipient) => {
    setTempOrder((prevOrder) => ({ ...prevOrder, recipient }));
  };

  const handleCakeChange = (index, cake) => {
    setTempOrder((prevOrder) => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      updatedOrderItems[0].cakes[index] = cake;
      return { ...prevOrder, orderItems: updatedOrderItems };
    });
  };

  const handleCookiesChange = (index, cookies) => {
    setTempOrder((prevOrder) => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      updatedOrderItems[0].cookies[index] = cookies;
      return { ...prevOrder, orderItems: updatedOrderItems };
    });
  };

  const handleCakePopsChange = (index, cakePops) => {
    setTempOrder((prevOrder) => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      updatedOrderItems[0].cakePops[index] = cakePops;
      return { ...prevOrder, orderItems: updatedOrderItems };
    });
  };

  const handleCupcakesChange = (index, cupcakes) => {
    setTempOrder((prevOrder) => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      updatedOrderItems[0].cupcakes[index] = cupcakes;
      return { ...prevOrder, orderItems: updatedOrderItems };
    });
  };

  const handleGeneralItemsChange = (index, generalItems) => {
    setTempOrder((prevOrder) => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      updatedOrderItems[0].generalItems[index] = generalItems;
      return { ...prevOrder, orderItems: updatedOrderItems };
    });
  };

  const handleFeeItemsChange = (index, feeItems) => {
    setTempOrder((prevOrder) => {
      const updatedAdditionalFees = JSON.parse(JSON.stringify(prevOrder.additionalFees));
      updatedAdditionalFees[index] = feeItems;
      return { ...prevOrder, additionalFees: updatedAdditionalFees };
    });
  };

  const handleDiscountItemsChange = (index, discountItems) => {
    setTempOrder((prevOrder) => {
      const updatedDiscounts = JSON.parse(JSON.stringify(prevOrder.discounts));
      updatedDiscounts[index] = discountItems;
      return { ...prevOrder, discounts: updatedDiscounts };
    });
  };

  const handleSave = async (patch = null, { stayEditable = false } = {}) => {
    setIsSaving(true);
    try {
      // always use the freshest state
      const current = orderRef.current;
      const payload = patch ? { ...current, ...patch } : current;

      let saved;
      if (payload._id) {
        saved = await OrderService.updateOrder(payload._id, payload);
        setTempOrder(saved);
      } else {
        saved = await OrderService.createOrder(payload);
        setTempOrder(saved);
      }

      await refreshOrders();
      if (!stayEditable) setEditable(false);
    } catch (error) {
      console.error('Error saving order:', error);
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to save the order. Please try again.' });
    } finally {
      setIsSaving(false);
    }
  };



  const items = [
    {
      label: 'Add Cake',
      icon: <FaBirthdayCake style={{ color: '#FFD700' }} />, // Gold color for cakes
      command: addCake,
    },
    {
      label: 'Add Cookies',
      icon: <FaCookieBite style={{ color: '#DEB887' }} />, // Burlywood color for cookies
      command: addCookies,
    },
    {
      label: 'Add Cake Pops',
      icon: <CiLollipop style={{ color: '#FF69B4' }} />, // Hotpink color for cake pops
      command: addCakePops,
    },
    {
      label: 'Add Cupcakes',
      icon: <GiCupcake style={{ color: '#FF6347' }} />, // Tomato color for cupcakes
      command: addCupcakes,
    },
    {
      label: 'Add General Items',
      icon: 'pi pi-fw pi-plus',
      command: addGeneralItems,
    },
    {
      label: 'Add Fee',
      icon: 'pi pi-fw pi-plus',
      command: addAdditionalFee,
    },
    {
      label: 'Add Discount',
      icon: <FaGift style={{ color: '#32CD32' }} />, // LimeGreen color for general items
      command: addDiscount,
    },
  ];

  const start = <Button label="Operations" icon="pi pi-fw pi-file" />; // Button for other operations
  const end = <Button label="Actions" icon="pi pi-fw pi-cog" />;  // Button for settings or additional actions


  const deepDeleteId = (obj) => {
    for (let key in obj) {
      if (key === "_id") {
        delete obj[key];
      } else if (typeof obj[key] === "object") {
        deepDeleteId(obj[key]);
      }
    }
  }

  const removeAdditionalFee = (index) => {
    setTempOrder(prevOrder => {
      const updatedAdditionalFees = JSON.parse(JSON.stringify(prevOrder.additionalFees));
      updatedAdditionalFees.splice(index, 1);
      return {
        ...prevOrder,
        additionalFees: updatedAdditionalFees,
      };
    });
  };

  const removeDiscount = (index) => {
    setTempOrder(prevOrder => {
      const updatedDiscounts = JSON.parse(JSON.stringify(prevOrder.discounts));
      updatedDiscounts.splice(index, 1);
      return {
        ...prevOrder,
        discounts: updatedDiscounts,
      };
    });
  };

  const removeCake = (index) => {
    setTempOrder(prevOrder => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      if (updatedOrderItems[0].cakes && updatedOrderItems[0].cakes.length > 0) {
        deepDeleteId(updatedOrderItems[0].cakes[index]);
        updatedOrderItems[0].cakes.splice(index, 1);
        return {
          ...prevOrder,
          orderItems: updatedOrderItems,
        };
      }
      return prevOrder;
    });
  };

  const removeCookies = (index) => {
    setTempOrder(prevOrder => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      if (updatedOrderItems[0].cookies && updatedOrderItems[0].cookies.length > 0) {
        updatedOrderItems[0].cookies.splice(index, 1);
        return {
          ...prevOrder,
          orderItems: updatedOrderItems,
        };
      }
      return prevOrder;
    });
  };

  const removeCakePops = (index) => {
    setTempOrder(prevOrder => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      if (updatedOrderItems[0].cakePops && updatedOrderItems[0].cakePops.length > 0) {
        updatedOrderItems[0].cakePops.splice(index, 1);
        return {
          ...prevOrder,
          orderItems: updatedOrderItems,
        };
      }
      return prevOrder;
    });
  };

  const removeCupcakes = (index) => {
    setTempOrder(prevOrder => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      if (updatedOrderItems[0].cupcakes && updatedOrderItems[0].cupcakes.length > 0) {
        updatedOrderItems[0].cupcakes.splice(index, 1);
        return {
          ...prevOrder,
          orderItems: updatedOrderItems,
        };
      }
      return prevOrder;
    });
  };

  const removeGeneralItems = (index) => {
    setTempOrder(prevOrder => {
      const updatedOrderItems = JSON.parse(JSON.stringify(prevOrder.orderItems));
      if (updatedOrderItems[0].generalItems && updatedOrderItems[0].generalItems.length > 0) {
        updatedOrderItems[0].generalItems.splice(index, 1);
        return {
          ...prevOrder,
          orderItems: updatedOrderItems,
        };
      }
      return prevOrder;
    });
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTempOrder({
      ...tempOrder,
      [name]: value,
    });
  };

  // Function to convert 24-hour format time to 12-hour format
  function convertTo12Hour(time) {
    let [hours, minutes] = time.split(":");
    let period = Number(hours) >= 12 ? 'PM' : 'AM';
    hours = ((Number(hours) + 11) % 12 + 1);
    return { hours: `${hours}`, minutes, period };
  }

  // Function to convert 12-hour format time to 24-hour format
  function convertTo24Hour(hours, minutes, period) {
    if (period === 'PM' && hours !== '12') {
      hours = Number(hours) + 12;
    } else if (period === 'AM' && hours === '12') {
      hours = '00';
    }
    return `${hours}:${minutes}`;
  }



  const header = () => {
    const timeOptions = Array.from({ length: 12 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` }));
    const minutesOptions = Array.from({ length: 12 }, (_, i) => ({ label: `${i * 5}`.padStart(2, '0'), value: `${i * 5}`.padStart(2, '0') }));
    const periodOptions = [{ label: 'AM', value: 'AM' }, { label: 'PM', value: 'PM' }];

    const { hours, minutes, period } = convertTo12Hour(tempOrder.scheduledTime);

    const handleCancel = () => {
      setTempOrder(JSON.parse(JSON.stringify(order))); // Reset to original order
      setEditable(false); // Exit edit mode
    };

    return (
      <div className="order-header">
        {/* Left Side: Order ID and Name */}
        <div className="order-header-left">
          {editable ? (
            <>
              <span className="order-id">Order ID: </span>
              <InputText
                value={tempOrder.orderID}
                onChange={(e) => setTempOrder({ ...tempOrder, orderID: e.target.value })}
                placeholder="Enter ID"
                className="p-mr-2"
                size="5"
              />
            </>
          ) : (
            <Avatar label={tempOrder.orderID} size="large" shape="circle" className="p-mr-2" />
          )}

          {editable ? (
            <>
              <span className="order-name">Order Name: </span>
              <InputText
                value={tempOrder.name}
                onChange={(e) => setTempOrder({ ...tempOrder, name: e.target.value })}
                placeholder="Enter Order Name"
                className="p-mr-2"
              />
            </>
          ) : (
            <strong>{tempOrder.name}</strong>
          )}
        </div>

        {/* Right Side: Due Date, Scheduled Time, Type */}
        <div className="order-header-right">
          {editable && <span className="due-date">Due Date: </span>}
          {editable ? (
            <Calendar
              value={tempOrder.dueDate ? new Date(tempOrder.dueDate) : ''}
              onChange={(e) => setTempOrder({ ...tempOrder, dueDate: e.value })}
              readOnlyInput={false}
              showIcon
              className="p-mr-2"
            />
          ) : (
            <span className="due-date">{formatDateWeekday(order.dueDate)}, {formatDateLong(order.dueDate)}</span>
          )}

          {editable && <span className="scheduled-time">Scheduled Time: </span>}
          {editable ? (
            <div className="time-dropdowns p-mr-2">
              <Dropdown
                options={timeOptions}
                value={hours}
                onChange={(e) => setTempOrder({ ...tempOrder, scheduledTime: convertTo24Hour(e.value, minutes, period) })}
                className="p-mr-2"
              />
              <Dropdown
                options={minutesOptions}
                value={minutes}
                onChange={(e) => setTempOrder({ ...tempOrder, scheduledTime: convertTo24Hour(hours, e.value, period) })}
                className="p-mr-2"
              />
              <Dropdown
                options={periodOptions}
                value={period}
                onChange={(e) => setTempOrder({ ...tempOrder, scheduledTime: convertTo24Hour(hours, minutes, e.value) })}
              />
            </div>
          ) : (
            <span className="scheduled-time">{hours}:{minutes} {period}</span>
          )}

          {editable && <span className="order-type">Type: </span>}
          {editable ? (
            <Dropdown
              value={tempOrder.type}
              options={orderProperties[0]?.selections?.fulfillment_type.sort()}
              onChange={(e) => setTempOrder({ ...tempOrder, type: e.value })}
              placeholder="Select a Type"
              filter
              className="p-mr-2"
            />
          ) : (
            <span className="order-type">{tempOrder.type}</span>
          )}


        </div>
        {editable && (
          <div className="action-buttons">
            <Button
              icon="pi pi-save"
              rounded
              severity="success"
              onClick={() => handleSave()} 
              disabled={isSaving}
            />
            <Button
              icon="pi pi-times"
              rounded
              severity="danger"
              onClick={handleCancel}
            />
          </div>
        )}
      </div>
    );
  };




  const calculateOrderPrice = (orderItems) => {
    let totalPrice = 0;

    // For Cakes
    orderItems.cakes.forEach(cake => {
      // Sum up each tier's price
      cake.tiers.forEach(tier => {
        totalPrice += tier.price ? parseFloat(tier.price) : 0;
        totalPrice += tier.premiumFillingPrice &&
          //make sure premiumFilling type is number if not set to 0
          typeof tier.premiumFillingPrice === 'number'
          ? tier.premiumFillingPrice : 0;
        totalPrice += tier.soakPrice ? parseFloat(tier.soakPrice) : 0;
        totalPrice += tier.extrasPrice ? parseFloat(tier.extrasPrice) : 0;
      });

      // Add topper price if exists
      if (cake.toppers.length) {
        cake.toppers.forEach(topper => {
          totalPrice += topper.price ? parseFloat(topper.price) : 0;
        });
      }

      if (cake.decoratingItems.length) {
        cake.decoratingItems.forEach(decoratingItem => {
          totalPrice += decoratingItem.price ? parseFloat(decoratingItem.price) : 0;
        });
      }
    });

    // For Cookies
    orderItems.cookies.forEach(cookie => {
      totalPrice += ((cookie.quantity ? parseInt(cookie.quantity) : 0) * (cookie.price ? parseFloat(cookie.price) : 0));
    });

    // For Cupcakes
    orderItems.cupcakes.forEach(cupcake => {
      totalPrice += ((cupcake.quantity ? parseInt(cupcake.quantity) : 0) * (cupcake.price ? parseFloat(cupcake.price) : 0));
    });

    // For Cake Pops
    orderItems.cakePops.forEach(cakePop => {
      totalPrice += ((cakePop.quantity ? parseInt(cakePop.quantity) : 0) * (cakePop.price ? parseFloat(cakePop.price) : 0));
    });

    // For General Items
    orderItems.generalItems.forEach(item => {
      totalPrice += ((item.quantity ? parseInt(item.quantity) : 0) * (item.price ? parseFloat(item.price) : 0));
    });

    return totalPrice;
  };

  const orderPrice = (calculateOrderPrice(tempOrder.orderItems[0]) + (tempOrder.deliveryFee ? parseFloat(tempOrder.deliveryFee) : 0)
    + (tempOrder.additionalFees ? tempOrder.additionalFees.reduce((a, b) => a + (b['price'] || 0), 0) : 0)
    - (tempOrder.discounts ? tempOrder.discounts.reduce((a, b) => a + (b['price'] || 0), 0) : 0)
  );

  const OrderItemSection = React.memo(({ title, children }) => (
    <Collapse title={
      <div>
        <Text h1 size={26} css={{ textGradient: "45deg, $blue600 -20%, $pink600 50%" }} weight="extrabold">
          {title}
        </Text>
      </div>
    } expanded shadow divider={false} bordered>
      {children}
    </Collapse>
  ));

  const Title = React.memo((title) => (
    <div>
      <Text h1 size={26} css={{ textGradient: "45deg, $blue600 -20%, $pink600 50%" }} weight="extrabold">
        {title}
      </Text>
    </div>
  ));


  return (
    <>
      {header()}

      {/* Menubar */}
      {editable && (
        <div className="order-menubar">
          <Menubar model={items} />
        </div>
      )}

      <div className={`order-main-content`}>
        {/* Left Panel: Customer, Order Details, Recipient */}
        <div className="left-panel">
          <Customer
            customer={tempOrder.customer}
            order={tempOrder}
            editable={editable}
            handleCustomerChange={handleCustomerChange}
            linkInvoiceToOrder={linkInvoiceToOrder}
            customers={customers}
            filteredPhoneNumbers={filteredPhoneNumbers}
            filteredEmails={filteredEmails}
          />
          <>
            <div
              style={{
                paddingTop: "0.25rem",
                paddingBottom: "0.25rem",
                paddingLeft: "1rem",
                paddingRight: "1rem",
                border: "1px solid #eaeaea",
                borderRadius: "10px",
                background: "black",
                marginBottom: "0.25rem",
                marginTop: "0.25rem",
                marginLeft: "0.5rem",
                marginRight: "0.5rem",
                textAlign: "center",
                fontSize: "1.25rem",
                fontWeight: "bold",
                color: "white",
                //letter spacing
                letterSpacing: "0.15rem",
                marginTop: "10px",
              }}
            >
              <strong>Order Details</strong>
            </div>
            <Grid.Container gap={editable ? 1 : 2}>
              {[
                ["Description", "description", tempOrder.description],
                // ["Budget", "budget", tempOrder.budget, "number"],
                // ["Price", "price", tempOrder.price, "number"],
                [
                  "Invoice Status",
                  "invoiceStatus",
                  tempOrder.invoiceStatus,
                  "dropdown",
                  orderProperties[0]?.selections?.invoice_statuses?.sort(),
                ],
                [
                  tempOrder.type === "Pick Up" && tempOrder.deliveryAddress
                  ? "Delivery Address (Unconfirmed)"
                  : "Delivery Address",
                  "deliveryAddress",
                  tempOrder.deliveryAddress,
                ],
                [
                  "Delivery Fee",
                  "deliveryFee",
                  tempOrder.deliveryFee,
                  "number",
                ],
                ["Occasion", "ocassion", tempOrder.ocassion],
                ["Theme", "theme", tempOrder.theme],
                ["Servings", "servings", tempOrder.servings],
                ["Order Note", "orderNote", tempOrder.orderNote],
              ]
                .map(([label, name, value, type = "text", options], index) => {
                  if (
                    editable ||
                    (value != null && value !== "" && value !== 0)
                  ) {
                    return (
                      <Grid key={index}>
                        {editable ? (
                          <EditableField
                            label={label}
                            name={name}
                            value={value}
                            onChange={handleInputChange}
                            type={type}
                            options={options}
                          />
                        ) : (
                          <NonEditableField label={label} value={value} />
                        )}
                      </Grid>
                    );
                  }
                  return null;
                })
                .filter(Boolean)}
              {/* <Grid>
              {tempOrder.photo && <img src={tempOrder.photo} alt="Order" />}
            </Grid> */}
              <Grid>
                {
                  //calculateOrderPrice(tempOrder.orderItems[0]) > 0 &&
                  <>
                    <strong>Order Total:</strong>
                    <br />
                    {formatToUSD(orderPrice)}
                  </>
                }
              </Grid>

              {tempOrder?.squareInvoiceID && selectedOrderInvoice?.invoice && (
                <Grid>
                  {(() => {
                    // `paymentRequests` is an array of multiple installments or deposits in the invoice
                    const paymentRequests =
                      selectedOrderInvoice.invoice.paymentRequests ?? [];

                    // Sum up each request's "computedAmountMoney.amount" to figure out the total
                    const totalCents = paymentRequests.reduce((acc, req) => {
                      // If there's a computedAmountMoney, use that; else 0
                      const amtStr = req?.computedAmountMoney?.amount ?? "0";
                      return acc + parseInt(amtStr, 10);
                    }, 0);

                    const invoiceTotal = totalCents / 100; // Convert from cents to dollars

                    // Compare the totals
                    const doesNotMatch =
                      Math.abs(invoiceTotal - orderPrice) > 0.001;

                    return (
                      <>
                        <strong>Square Invoice Total:</strong>
                        <br />
                        {formatToUSD(invoiceTotal)}
                        {doesNotMatch && " (Does not match Order)"}
                      </>
                    );
                  })()}
                </Grid>
              )}
            </Grid.Container>

            <Recipient
              recipient={tempOrder.recipient}
              editable={editable}
              handleRecipientChange={handleRecipientChange}
            />

            {/* Photo Upload Section */}
            {/* {editable && <PhotoUploadSection />} */}
          </>
        </div>

        {/* Right Side: Order Items */}
        {/* Right Panel: Order Items */}
        <div className="right-panel">
          <div className="order-accordion">
            <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]}>
              {((tempOrder.photos && tempOrder.photos.length > 0) ||
                editable) && (
                <AccordionTab
                  header={
                    <div>
                      <Text
                        h1
                        size={22}
                        css={{
                          textGradient: "45deg, $blue600 -20%, $pink600 50%",
                        }}
                        weight="extrabold"
                      >
                        Photos
                      </Text>
                    </div>
                  }
                >
                 <PhotoManager
                    photos={tempOrder.photos}
                    editable={editable}
                    onAddPhoto={handleAddPhoto}
                    onRemovePhoto={handleRemovePhoto}
                    canUpload={Boolean(tempOrder?.customer?.name)}
                    autoSave={Boolean(tempOrder?._id)}
                    onAutoSave={(newlyAdded = []) => {
                      const merged = mergeUniquePhotos(orderRef.current.photos || [], newlyAdded);
                      return handleSave(
                        { photos: merged, photoAttached: merged.length > 0 },
                        { stayEditable: true }
                      );
                    }}
                  />

                </AccordionTab>
              )}
              {tempOrder.orderItems &&
                tempOrder.orderItems[0].cakes &&
                tempOrder.orderItems[0].cakes.length > 0 && (
                  <AccordionTab
                    header={
                      <div>
                        <Text
                          h1
                          size={22}
                          css={{
                            textGradient: "45deg, $blue600 -20%, $pink600 50%",
                          }}
                          weight="extrabold"
                        >
                          Cakes
                        </Text>
                      </div>
                    }
                  >
                    <Cakes
                      cake={tempOrder.orderItems[0].cakes}
                      productProperties={productProperties}
                      editable={editable}
                      employees={employees}
                      removeCake={removeCake}
                      handleCakeChange={handleCakeChange}
                    />
                  </AccordionTab>
                )}
              {tempOrder.orderItems &&
                tempOrder.orderItems[0].cupcakes &&
                tempOrder.orderItems[0].cupcakes.length > 0 && (
                  <AccordionTab
                    header={
                      <div>
                        <Text
                          h1
                          size={22}
                          css={{
                            textGradient: "45deg, $blue600 -20%, $pink600 50%",
                          }}
                          weight="extrabold"
                        >
                          Cupcakes
                        </Text>
                      </div>
                    }
                  >
                    <Cupcakes
                      cupcakes={tempOrder.orderItems[0].cupcakes}
                      productProperties={productProperties}
                      editable={editable}
                      employees={employees}
                      removeCupcakes={removeCupcakes}
                      handleCupcakesChange={handleCupcakesChange}
                    />
                  </AccordionTab>
                )}
              {tempOrder.orderItems &&
                tempOrder.orderItems[0].cakePops &&
                tempOrder.orderItems[0].cakePops.length > 0 && (
                  <AccordionTab
                    header={
                      <div>
                        <Text
                          h1
                          size={22}
                          css={{
                            textGradient: "45deg, $blue600 -20%, $pink600 50%",
                          }}
                          weight="extrabold"
                        >
                          Cake Pops/Balls
                        </Text>
                      </div>
                    }
                  >
                    <CakePops
                      cakePops={tempOrder.orderItems[0].cakePops}
                      productProperties={productProperties}
                      editable={editable}
                      employees={employees}
                      removeCakePops={removeCakePops}
                      handleCakePopsChange={handleCakePopsChange}
                    />
                  </AccordionTab>
                )}
              {tempOrder.orderItems &&
                tempOrder.orderItems[0].cookies &&
                tempOrder.orderItems[0].cookies.length > 0 && (
                  <AccordionTab
                    header={
                      <div>
                        <Text
                          h1
                          size={22}
                          css={{
                            textGradient: "45deg, $blue600 -20%, $pink600 50%",
                          }}
                          weight="extrabold"
                        >
                          Cookies
                        </Text>
                      </div>
                    }
                  >
                    <Cookies
                      cookies={tempOrder.orderItems[0].cookies}
                      productProperties={productProperties}
                      editable={editable}
                      employees={employees}
                      removeCookies={removeCookies}
                      handleCookiesChange={handleCookiesChange}
                    />
                  </AccordionTab>
                )}
              {tempOrder.orderItems &&
                tempOrder.orderItems[0].generalItems &&
                tempOrder.orderItems[0].generalItems.length > 0 && (
                  <AccordionTab
                    header={
                      <div>
                        <Text
                          h1
                          size={22}
                          css={{
                            textGradient: "45deg, $blue600 -20%, $pink600 50%",
                          }}
                          weight="extrabold"
                        >
                          General Items
                        </Text>
                      </div>
                    }
                  >
                    <GeneralItems
                      generalItems={tempOrder.orderItems[0].generalItems}
                      productProperties={productProperties}
                      editable={editable}
                      employees={employees}
                      removeGeneralItems={removeGeneralItems}
                      handleGeneralItemsChange={handleGeneralItemsChange}
                    />
                  </AccordionTab>
                )}
              {tempOrder.additionalFees &&
                tempOrder.additionalFees.length > 0 && (
                  <AccordionTab
                    header={
                      <div>
                        <Text
                          h1
                          size={22}
                          css={{
                            textGradient: "45deg, $blue600 -20%, $pink600 50%",
                          }}
                          weight="extrabold"
                        >
                          Additional Fees
                        </Text>
                      </div>
                    }
                  >
                    <FeeItems
                      feeItems={tempOrder.additionalFees}
                      editable={editable}
                      removeFeeItems={removeAdditionalFee}
                      handleFeeItemsChange={handleFeeItemsChange}
                    />
                  </AccordionTab>
                )}
              {tempOrder.discounts && tempOrder.discounts.length > 0 && (
                <AccordionTab
                  header={
                    <div>
                      <Text
                        h1
                        size={22}
                        css={{
                          textGradient: "45deg, $blue600 -20%, $pink600 50%",
                        }}
                        weight="extrabold"
                      >
                        Discounts
                      </Text>
                    </div>
                  }
                >
                  <DiscountItems
                    discountItems={tempOrder.discounts}
                    editable={editable}
                    removeDiscountItems={removeDiscount}
                    handleDiscountItemsChange={handleDiscountItemsChange}
                  />
                </AccordionTab>
              )}
              {tempOrder._id && (
                <AccordionTab
                  header={
                    <div>
                      <Text
                        h1
                        size={22}
                        css={{
                          textGradient: "45deg, $blue600 -20%, $pink600 50%",
                        }}
                        weight="extrabold"
                      >
                        Invoices
                      </Text>
                    </div>
                  }
                >
                  {PotentialInvoices}
                </AccordionTab>
              )}
              {!editable && tempOrder._id && (
                <AccordionTab
                  header={
                    <div>
                      <Text
                        h1
                        size={22}
                        css={{
                          textGradient: "45deg, $blue600 -20%, $pink600 50%",
                        }}
                        weight="extrabold"
                      >
                        Invoice Generator
                      </Text>
                    </div>
                  }
                >
                  <InvoiceGenerator
                    productProperties={productProperties}
                    order={tempOrder}
                    orderPrice={orderPrice}
                  />
                </AccordionTab>
              )}
            </Accordion>
          </div>
        </div>
        {/* <Dialog
          visible={isDialogVisible}
          onHide={closeDialog}
          header={`Photo ${currentPhotoIndex + 1}`}
          style={{ width: "50vw" }}
          footer={
            tempOrder.photos?.length > 0 && (
              <div>
                <Button
                  label="Previous"
                  icon="pi pi-arrow-left"
                  onClick={() => handleNavigation(-1)}
                  className="p-button-text"
                />
                <Button
                  label="Download"
                  icon="pi pi-download"
                  onClick={() =>
                    downloadPhoto(tempOrder.photos[currentPhotoIndex]?.url)
                  }
                  className="p-button-success"
                />
                <Button
                  label="Next"
                  icon="pi pi-arrow-right"
                  onClick={() => handleNavigation(1)}
                  className="p-button-text"
                />
              </div>
            )
          }
        >
          <div style={{ textAlign: "center" }}>
            {tempOrder.photos?.length > 0 ? (
              <img
                src={tempOrder.photos[currentPhotoIndex]?.url}
                alt={`Photo ${currentPhotoIndex + 1}`}
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            ) : (
              <p>No photos available.</p>
            )}
          </div>
        </Dialog> */}
      </div>
    </>
  );
};

export default OrderViewEdit;



const aggregateItemsByFlavor = (items) => {
  return items.reduce((groups, item) => {
    if (!groups[item.flavor]) {
      groups[item.flavor] = [];
    }
    groups[item.flavor].push(item);
    return groups;
  }, {});
};

const aggregateItemsByItem = (items) => {
  return items.reduce((groups, item) => {
    if (!groups[item.item]) {
      groups[item.item] = [];
    }
    groups[item.item].push(item);
    return groups;
  }, {});
};





// const determinePickupRange2 = (scheduledTime, scheduledDay) => {
//   if (scheduledDay === 'Saturday') {
//     return `${scheduledTime}AM-12:00PM`;
//   } else {
//     let timeParts = scheduledTime.split(':');
//     console.log('timeparts:', timeParts);
//     let hour = parseInt(timeParts[0]);
//     if (hour < 13) {
//       return `${scheduledTime}${scheduledTime >= 12 ? 'AM' : 'PM'}-1:00PM or 2:00PM-5:00PM`;
//     } else {
//       return `${(timeParts[0] - 12) + ':' + timeParts[1]}PM-5:00PM`;
//     }
//   }
//   return scheduledTime;
// };

const determinePickupRange = (isDelivery, scheduledTime, scheduledDay) => {
  const formatTime = (hour, minute) => {
    let isPM = hour >= 12;
    let formattedHour = hour > 12 ? hour - 12 : hour;
    formattedHour = formattedHour === 0 ? 12 : formattedHour; // Handle midnight and noon
    return `${formattedHour}:${minute < 10 ? `${minute}` : minute}${isPM ? 'PM' : 'AM'}`;
  };

  if (isDelivery) {
    let timeParts = scheduledTime.split(':');
    let endHour = parseInt(timeParts[0]);
    let endMinute = timeParts[1];
    let startHour = endHour + 2;
    return `${formatTime(endHour, endMinute)} - ${formatTime(startHour, endMinute)}`;
  } else {
    let timeParts = scheduledTime.split(':');
    let hour = parseInt(timeParts[0]);
    let minute = timeParts[1];

    if (scheduledDay === 'Saturday') {
      if (scheduledTime === '11:00') {
        return '11:00AM-12:00PM';
      } else {
        let endHour = hour + 1;
        return `${formatTime(hour, minute)} - ${formatTime(endHour, minute)}`;
      }
    } else if (scheduledDay === 'Sunday') {
      let endHour = hour + 1;
      return `${formatTime(hour, minute)} - ${formatTime(endHour, minute)}`;
    } else {
      // Handling for Monday to Friday non-deliveries
      if (hour < 12) {
        return `${formatTime(hour, minute)}-12:00PM or 2:00PM-5:00PM`;
      } else if (hour === 12) {
        return '12:00PM-1:00PM or 2:00PM-5:00PM';
      } else {
        return `${formatTime(hour, minute)}-5:00PM`;
      }
    }
  }
  // Fallback case, if needed
  return scheduledTime;
};



// Helper Components
const Title = ({ text }) => (
  <div style={{
    paddingTop: '0.75rem',
    paddingBottom: '0.75rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    border: '1px solid #eaeaea',
    borderRadius: '10px',
    background: '#2b2b2b',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 'bold',
    color: 'white',
    letterSpacing: '0.25rem',
    marginTop: '10px'
  }}>
    <strong>{text}</strong>
  </div>
);

const Section = ({ title, children }) => (
  <div>
    <h3>{title}</h3>
    {children}
  </div>
);

const LineItem = ({ text }) => <p>{text}</p>;


const InvoiceGenerator = ({ productProperties, order, orderPrice }) => {

  const baseAddress = "1150 Empire Central Pl #102 Dallas, TX 75247";

  const scheduledDay = new Date(order.dueDate).toLocaleString('en-US', { weekday: 'long' });
  const pickUpRange = determinePickupRange(order.type == 'Delivery', order.scheduledTime, scheduledDay);

  // Determine the action (pick up or delivery) based on order type
  const action = order.type === "Pick Up" ? "Pick up" : "Delivery";

  const [numberOfPayments, setNumberOfPayments] = useState(2);
  //default to today's date
  const [invoiceDueDate, setInvoiceDueDate] = useState(new Date());

  // Calculate installment amount
  const installmentAmount = orderPrice / numberOfPayments;

  // Determine payment plan message
  let paymentPlanMessage;
  if (numberOfPayments === 1) {
    paymentPlanMessage = `${formatToUSD(installmentAmount)}`;
  } else {
    //paymentPlanMessage = `This invoice is split into ${numberOfPayments} payments of ${formatToUSD(installmentAmount)} each. Further payment details will be provided separately.`;
    paymentPlanMessage = `${formatToUSD(installmentAmount)} (Remaining balance of ${formatToUSD(installmentAmount)} will be due upon or before pick up)`
  }

  const displayDueDate = invoiceDueDate ? new Date(invoiceDueDate) : new Date(order.contactDate);


  return (
    <div>
      {/* Dropdown for number of payments */}
      <p>Number of Payments:</p>
      <Dropdown
        value={numberOfPayments}
        options={[1, 2,].map(n => ({ label: `${n} Payment${n > 1 ? 's' : ''}`, value: n }))}
        onChange={(e) => setNumberOfPayments(e.value)}
        style={{ width: '100%', marginBottom: '1rem' }}
      />
      <p>Invoice Due Date:</p>
      <Calendar value={invoiceDueDate} onChange={(e) => setInvoiceDueDate(e.value)} showIcon style={{ width: '100%', marginBottom: '1rem' }} />
      <div style={{
        padding: '1rem',
      }}>
        <h2>Invoice for {order.customer.name}</h2>
        <p>Below is the initial invoice covering the down payment for the specified order:</p><br />
        <p><strong>Order Due Date:</strong>  {formatDateWeekday(order.dueDate)}{', '}{formatDateLong(order.dueDate)}</p>
        {/* Display pick up or delivery details based on the order type */}
        <p><strong>{action} Time:</strong> {pickUpRange}</p>
        {order.type === "Pick Up" ?
          <p><strong>Pick up Location:</strong> {baseAddress}</p>
          :
          <p><strong>Delivery Address:</strong> {order.deliveryAddress}</p>
        }<br />
        <strong><h3>Order:</h3></strong>
        <p>{generateOrderDescription(order.orderItems[0], productProperties).split('\n').map((line, index) => <span key={index}>{line}<br /></span>)}</p><br />
        {/* {order.additionalFees.length > 0 && <p><strong>Fees:</strong> {order.additionalFees.map((fee, index) => <div key={index}>{fee.description} (+{formatToUSD(fee.price)})<br /></div>)}<br /></p>}
        {order.discounts.length > 0 && <p><strong>Discounts:</strong> {order.discounts.map((discount, index) => <div key={index}>{discount.description} (-{formatToUSD(discount.price)})<br /></div>)}<br /></p>} */}
        {order.additionalFees.length > 0 && (
          <div>
            <strong>Fees:</strong>
            {order.additionalFees.map((fee, index) => (
              <div key={index}>{fee.description} (+{formatToUSD(fee.price)})<br /></div>
            ))}
            <br />
          </div>
        )}
        {order.discounts.length > 0 && (
          <div>
            <strong>Discounts:</strong>
            {order.discounts.map((discount, index) => (
              <div key={index}>{discount.description} (-{formatToUSD(discount.price)})<br /></div>
            ))}
            <br />
          </div>
        )}
        <p><strong>Total:</strong> {formatToUSD(orderPrice)}</p>
        {/* <p><strong>Due Today:</strong> {formatToUSD(orderPrice / 2)} (Remaining balance of {formatToUSD(orderPrice / 2)} will be due upon or before {action.toLowerCase()})</p><br /> */}
        <p><strong>Due Today:</strong> {paymentPlanMessage}</p><br />
        <p>Thank you for your business. I hope you have a Sweet day!</p>
        <p>Please Note: This invoice is valid only until 5pm on {new Date(displayDueDate).toDateString()} only. If you cannot present payment within the deadline and still wish to proceed with your order, please email us and request an extension before the deadline. Deposits are non-refundable, and the date of availability is only guaranteed upon this payment.</p>
      </div>
    </div>
  );
};

const NonEditableFieldWithCurrency = ({ label, value }) => (
  <div className="field">
    <strong><label>{label}</label></strong>
    <div>{formatToUSD(value)}</div>
  </div>
);

function convertTo12Hour(time) {
  let [hours, minutes] = time.split(":");
  let period = Number(hours) >= 12 ? 'PM' : 'AM';
  hours = ((Number(hours) + 11) % 12 + 1);
  return { hours: `${hours}`, minutes, period };
}